import endpoints from "./endpoints.config"
import envs from "./envs.config"

export default {
    endpoints,
    envs
}
